import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SnackbarComponent } from './snackbar.component';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [SnackbarComponent],
  imports: [CommonModule, MatIconModule],
  entryComponents: [SnackbarComponent],
})
export class SnackbarModule {}
